import { FormInstance } from 'antd/lib/form';
import { NamePath } from '@xbcb/ui-types';

// Note: the `fields` should be comprised of `fullNamePath`s
export const isRequired = (form: FormInstance, fields: NamePath[]) =>
  fields.some((field) => form.getFieldValue(field));
